/**
 * Pricing-check freshness (FR-5.8, HS2-N0RFQQ) — shared so the server and the report agree.
 *
 * A run that finished is `done`. Any later edit to the demand's line items or quotations marks it
 * `stale`: the report, its recommendations, benchmarks, and savings stay usable, but it no longer
 * counts as a fresh analysis, so the demand drops from `analysed` back to `quoting` until a re-run.
 */

/** A finished run whose results can be read: fresh (`done`) or out of date (`stale`). */
export function isFinishedAnalysisStatus(status: string): boolean {
  return status === 'done' || status === 'stale';
}

/** The finished statuses, for SQL `IN` filters. */
export const FINISHED_ANALYSIS_STATUSES = ['done', 'stale'] as const;
